import React from "react";
import { UserFundraiserList } from "../../components";
import { SINGLE_OWNER_PAGE } from "../../constants";

export default function PersonalFundraisers() {

    return <UserFundraiserList listType={SINGLE_OWNER_PAGE}/>
}